import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { User } from './user';

@inheritSerialization(AbstractModel)
export class RegistrationRider extends AbstractModel {

  @autoserializeAs(User)
  user: User;

  @autoserialize
  organizationId: number;

  @autoserialize
  partnerIdentifier: string;

  constructor() {
    super();
    this.user = new User();
  }
}
